import { render, staticRenderFns } from "./Usermenu.vue?vue&type=template&id=13b4bc10&"
import script from "./Usermenu.vue?vue&type=script&lang=js&"
export * from "./Usermenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports